import script from "./ArgonTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonTable.vue?vue&type=script&setup=true&lang=js"

import "./ArgonTable.vue?vue&type=style&index=0&id=083698ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-083698ef"]])

export default __exports__